import React from "react";
import { Box, Typography, Alert, AlertTitle } from "@mui/material";
import { missingConfig } from "../../config/apiUrls";

/**
 * Renders a readable page when required env vars are absent.
 *
 * Replaces the module-scope `throw new Error("... is not defined")` in
 * config/apiUrls.js and config/opusUrls.js. Those threw during module
 * evaluation — before React mounted — so no error boundary could catch them and
 * a single missing variable produced a blank page with only a console message.
 */
export function ConfigCheck({ children }) {
  if (!missingConfig.length) return children;
  return (
    <Box sx={{ p: 4 }}>
      <Alert severity="error">
        <AlertTitle>Configuration error</AlertTitle>
        <Typography variant="body2">
          The following environment variables are not set, so Aether cannot reach its backends:
        </Typography>
        <ul>
          {missingConfig.map((name) => (
            <li key={name}>
              <code>{name}</code>
            </li>
          ))}
        </ul>
      </Alert>
    </Box>
  );
}

export default ConfigCheck;
